'use client'

import React, { FC } from 'react'
import { Icon } from '@ads/front-ds'
import { EMAIL_SUPPORT } from '@ads/front-core/constants'
import { FingerPrint } from './Fingerprint'
import { ADBLOCK_INFO_CLASSNAME } from './constants'

const AdblockInfo: FC = () => (
  <div style={{ display: 'none' }} className={ADBLOCK_INFO_CLASSNAME}>
    <div className="one" />
    <div className="two">
      <button type="button" aria-label="Zamknij komunikat AdBlocka">
        <Icon name="20-close" />
      </button>
      <h1>Wykryty AdBlock</h1>
      <p>
        Aby móc korzystać z panelu WP Ads,
        <br />
        <b>wyłącz oprogramowanie blokujące reklamy</b>,<br />
        bądź dodaj naszą witrynę do wyjątków.
        <br />
        <br />W razie problemów skontaktuj się z naszym działem wsparcia:{' '}
        <a href={`mailto:${EMAIL_SUPPORT}`} target="_blank">
          {EMAIL_SUPPORT}
        </a>
      </p>
      <div>
        <FingerPrint />
      </div>
    </div>
  </div>
)

export default AdblockInfo
